import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import SigningAgentPage from "@/pages/SigningAgentPage";
import MobileNotaryPage from "@/pages/MobileNotaryPage";
import RONPage from "@/pages/RONPage";
import PricingPage from "@/pages/PricingPage";
import ContactPage from "@/pages/ContactPage";
import FAQPage from "@/pages/FAQPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import VendorPage from "@/pages/VendorPage";
import AdminPage from "@/pages/AdminPage";
import ApostillePage from "@/pages/ApostillePage";
import ResourcesPage from "@/pages/ResourcesPage";
import AppsPage from "@/pages/AppsPage";
import FieldTestedGearPage from "@/pages/FieldTestedGearPage";
import WeddingServicesPage from "@/pages/WeddingServicesPage";
import ElderCarePage from "@/pages/ElderCarePage";
import CommunityHubPage from "@/pages/CommunityHubPage";
import BlogPage from "@/pages/BlogPage";
import BlogArticlePage from "@/pages/BlogArticlePage";
import NewsletterArchivePage from "@/pages/NewsletterArchivePage";
import NewsletterIssuePage from "@/pages/NewsletterIssuePage";
import MobileNotaryFieldSopPage from "@/pages/MobileNotaryFieldSopPage";
import AuthCallback from "@/components/AuthCallback";
import NotFoundPage from "@/pages/NotFoundPage";
import { AuthProvider } from "@/context/AuthContext";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <AppRoutes />
          <Toaster richColors position="bottom-right" />
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

function AppRoutes() {
  const location = useLocation();
  // Detect Emergent OAuth callback synchronously during render.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/signing-agent" element={<SigningAgentPage />} />
        <Route path="/mobile-notary" element={<MobileNotaryPage />} />
        <Route path="/ron" element={<RONPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/vendor" element={<VendorPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/apostille" element={<ApostillePage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/apps" element={<AppsPage />} />
        <Route path="/gear" element={<FieldTestedGearPage />} />
        <Route path="/field-tested-gear" element={<FieldTestedGearPage />} />
        <Route path="/wedding-services" element={<WeddingServicesPage />} />
        <Route path="/elder-care" element={<ElderCarePage />} />
        <Route path="/community" element={<CommunityHubPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogArticlePage />} />
        <Route path="/newsletter" element={<NewsletterArchivePage />} />
        <Route path="/newsletter/archive" element={<NewsletterArchivePage />} />
        <Route path="/newsletter/:slug" element={<NewsletterIssuePage />} />
        <Route path="/mobile-notary-field-sop" element={<MobileNotaryFieldSopPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
